export const SET_UI_CONFIG = "@config/SET_UI_CONFIG";
export const CHECK_SESSION = "@config/CHECK_SESSION";
